<template functional>
    <b-tooltip :label="props.value.length > 23 ? props.value : ''">
        <div
            :class="props.value.length > 23 ? 'truncate' : ''"
            v-bind="data.attrs"
            >
            {{ props.value }}
         </div>
    </b-tooltip>
</template>

<script>
export default {
  name: 'DatasetCellText',
  props: {
    row: { type: Object, default: () => ({}) },
    columns: { type: Object, default: () => ({}) },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: () => null,
    },
  },
}
</script>

<style scoped>
.truncate {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 150px;
    }
</style>
